import { Stack } from "@mui/material";
import { useQuery } from "@tanstack/react-query";

import { useRequireParams } from "@/utils";
import { Title } from "@/components/Title";
import { usePageBottom } from "@/hooks/usePageBottom";
import { BackToTopButton } from "@/components/BackToTopButton";
import { getFacility } from "@/services/facility";

import {
  FacilityBookingCard,
  useFacilityBookingCardForm,
} from "./FacilityBookingCard";
import { FacilityDetailCard } from "./FacilityDetailCard";

const QUERY_KEY = "getFacility";

export function FacilityDetailPage() {
  const { id } = useRequireParams(["id"]);
  const reachedBottom = usePageBottom();

  const title = "เลือกวันและเวลา";

  const { control } = useFacilityBookingCardForm();

  const { data: raw, isFetching } = useQuery([QUERY_KEY], () =>
    getFacility(+id)
  );

  return (
    <Stack
      mx={{ xs: 3, sm: 6 }}
      gap={5}
      maxWidth="1024px"
      my={{ xs: 5, sm: 10 }}
      justifySelf="center"
    >
      <Title title={title} />
      <FacilityBookingCard control={control} data={raw} />
      <FacilityDetailCard data={raw} isFetching={isFetching} />
      {reachedBottom && <BackToTopButton />}
    </Stack>
  );
}
